import Color from "../../../assets/colors";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { styled as styling } from "@mui/material/styles";

export const Wrapper = styling(Grid)({
  backgroundColor: Color.lightblue,
  width: "100%",
  height: "100%",
  paddingBottom: "100px",
});

export const EmptyContainer = styling(Grid)({});

export const TypographyStyled = styling(Typography)({
  fontWeight: "bold",
  fontSize: "18px",
});

export const TypographyGreyStyled = styling(Typography)({
  color: "grey",
});

export const IconButtonStyled = styling(IconButton)({
  backgroundColor: Color.naikGreen,

  ":hover": {
    backgroundColor: Color.taglineGreen,
  },
});

export const NextIcon = styling(NavigateNextIcon)({
  color: "white",
});

export const BackIcon = styling(NavigateBeforeIcon)({
  color: "white",
});
